module.exports = __webpack_public_path__ + "media/images/social-icons/linkedin-white-8c64211fea3d494f245aa40a0341c35c.svg";